/**
 * Get language from user's browser settings
 * @return {String} language
 */
export function getLanguage() {
  const { userLanguage, language, languages } = window.navigator;
  if (languages && languages.length > 0) {
    return languages[0];
  }
  return language || userLanguage;
}
